import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';

export const JobColumns = [
  {
    id: 'title',
    disablePadding: true,
    label: 'Title',
  },
  {
    id: 'description',
    disablePadding: true,
    label: 'Description',
  },
  {
    id: 'organizationName',
    disablePadding: true,
    label: 'Organization Name',
  },
  {
    id: 'countryName',
    disablePadding: false,
    label: 'Country',
  },
  {
    id: 'jobTypeName',
    disablePadding: false,
    label: 'Job Type',
  },
  {
    id: 'userJobAppliedDate',
    disablePadding: false,
    label: 'Applied Date',
  },
  {
    id: 'action',
    disablePadding: false,
    label: 'Action',
  },
];

const createSortHandler = (property, onRequestSort) => (event) => {
  onRequestSort(event, property);
};

const JobTableColumns = ({ order, orderBy, rtl, onRequestSort }) => (
  <Fragment>
    <TableRow>
      {JobColumns.map((row) => (
        <TableCell
          className="material-table__cell material-table__cell--sort material-table__cell-center"
          key={row.id}
          align={'center'}
          padding={row.disablePadding ? 'none' : 'default'}
          sortDirection={orderBy === row.id ? order : false}
        >
          <TableSortLabel
            active={orderBy === row.id}
            direction={order}
            onClick={createSortHandler(row.id, onRequestSort)}
            className="material-table__sort-label"
            dir="ltr"
          >
            <b>{row.label}</b>
          </TableSortLabel>
        </TableCell>
      ))}
    </TableRow>
  </Fragment>
);

JobTableColumns.propTypes = {
  onRequestSort: PropTypes.func.isRequired,
  order: PropTypes.string.isRequired,
  orderBy: PropTypes.string.isRequired,
};

export default connect((state) => ({
  rtl: state.rtl,
}))(JobTableColumns);
